import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import React__default, { useRef, useState, useEffect } from 'react';
import './Notifications.scss.js';
import Notification from '../Notification/Notification.js';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { createPortal } from 'react-dom';

/** Стэк уведомлений */

var notifications$$ = new BehaviorSubject([]);
/** Удалить уведомление */

var removeNotification = function removeNotification(id) {
  if (notifications$$.closed || notifications$$.isStopped) {
    return;
  }

  var tmp = _toConsumableArray(notifications$$.getValue());

  if (tmp.length > 0) {
    if (id !== undefined) {
      tmp = tmp.filter(function (n) {
        return n.id !== id;
      });
    } else {
      tmp.shift();
    }

    notifications$$.next(tmp);
  }
};
/** Добавить уведомление */

var sendNotification = function sendNotification(message) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8000;

  if (notifications$$.closed || notifications$$.isStopped) {
    return;
  }

  var tmp = _toConsumableArray(notifications$$.getValue());

  tmp.push(Object.assign(Object.assign({}, message), {
    id: message.id || Date.now()
  }));
  notifications$$.next(tmp);
  setTimeout(function () {
    removeNotification(message.id);
  }, delay);
};

var Notifications = function Notifications(_ref) {
  var style = _ref.style;

  /** Флаг по которому остановить подписку */
  var obstacle = useRef(new Subject());

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      sub = _useState2[0],
      setSub = _useState2[1];

  useEffect(function () {
    if (notifications$$.closed) {
      notifications$$ = new BehaviorSubject([]);
    }

    setSub(notifications$$);
  }, []);
  /** Список уведомлений */

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      notifications = _useState4[0],
      setNotifications = _useState4[1]; // -------------------------------------------------------------------------------------------------------------------

  /** Подписываемся на список уведомлений */


  useEffect(function () {
    if (!sub || sub.closed) {
      return;
    }

    var until = obstacle.current;
    sub.pipe(takeUntil(until)).subscribe(function (data) {
      setNotifications(data);
    });
    return function () {
      until.next(true);
    };
  }, [sub]); // -------------------------------------------------------------------------------------------------------------------

  /** Список уведомлений TSX */

  var list = notifications.map(function (n, i) {
    return /*#__PURE__*/React__default.createElement(Notification, {
      key: n.id || i,
      item: n,
      remove: removeNotification,
      "data-v-6e52f9c7": ""
    });
  }); // -------------------------------------------------------------------------------------------------------------------

  if (!list.length) {
    return null;
  }

  return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "rf-notifications",
    className: "rf-notifications__list",
    style: style,
    "data-v-6e52f9c7": ""
  }, list), document.body);
};

export { Notifications as default, removeNotification, sendNotification };
